import { useCallback, useEffect, useMemo, useState } from 'react';
import { ID } from 'shared/types/id';

export const useOptimisticData = <Data extends { id: ID }>(
  data: Data[],
): [optimisticData: Data[], addDataItem: (item: Data) => void] => {
  const [optimisticData, setOptimisticData] = useState<Data[]>(data);

  const addDataItem = useCallback(
    (item: Data) => setOptimisticData((prev) => [...prev, item]),
    [],
  );

  useEffect(() => {
    const dataIds = new Set(data.map(({ id }) => id));
    const trulyOptimisticItems = optimisticData.filter(
      ({ id }) => !dataIds.has(id),
    );
    if (trulyOptimisticItems.length !== optimisticData.length) {
      setOptimisticData(trulyOptimisticItems);
    }
  }, [data, optimisticData]);

  const displayData = useMemo(
    () => [...data, ...optimisticData],
    [data, optimisticData],
  );

  return [displayData, addDataItem];
};
